<div class="containerBanner">
  <div class="menu-container">
    @if (showServiceRequestTable && !showForwardedReqTable &&
    !showApprovedRequest && !showPendingRequest && !showDeclinedRequest) {
    <h1>
      Service Requests<span>({{ this.totalService }})</span>
    </h1>
    } @if (showForwardedReqTable && !showApprovedRequest && !showPendingRequest
    && !showDeclinedRequest) {
    <h1>
      Forwarded Service Requests<span>({{ this.totalForwarded }})</span>
    </h1>
    } @if (showApprovedRequest && !showForwardedReqTable && !showPendingRequest
    && !showDeclinedRequest) {
    <h1>
      Approved Requests<span>({{ this.totalApproved }})</span>
    </h1>
    } @if (showPendingRequest && !showForwardedReqTable && !showApprovedRequest
    && !showDeclinedRequest) {
    <h1>
      Pending Requests<span>({{ this.totalPending }})</span>
    </h1>
    } @if (showDeclinedRequest && !showForwardedReqTable && !showApprovedRequest
    && !showPendingRequest && !showServiceRequestTable) {
    <h1>
      Declined Requests<span>({{ this.totalDeclined }})</span>
    </h1>
    }

    <div
      class="menu-content d-flex align-items-center justify-content-between"
      style="margin-bottom: 15px"
    >
      <div class="search-menu">
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="search-icon"
        >
          <g opacity="0.4">
            <circle
              cx="11.0795"
              cy="11.3768"
              r="7.62168"
              transform="rotate(-45 11.0795 11.3768)"
              stroke="#092C4C"
              stroke-width="1.72802"
              stroke-linecap="round"
            />
            <path
              d="M16.6416 16.9393L19.8465 20.1443"
              stroke="#092C4C"
              stroke-width="1.72802"
              stroke-linecap="round"
            />
          </g>
        </svg>
        @if(showServiceRequestTable && !showForwardedReqTable &&
        !showApprovedRequest && !showPendingRequest && !showDeclinedRequest){
        <input
          type="search"
          (keyup.enter)="onSearchServiceInventory()"
          [(ngModel)]="searchServiceReqQuery"
           placeholder="please hit enter after typing.."
        />
        @if(searchServiceReqQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearServiceReqSearch()"
        />} } @if(showApprovedRequest && !showForwardedReqTable &&
        !showPendingRequest && !showDeclinedRequest){
        <input
          type="search"
          (keyup.enter)="onSearchApprovedInventory()"
          [(ngModel)]="approvedSearchQuery"
          placeholder="Search Approved Requests"
        />
        @if(approvedSearchQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearApprovedSearch()"
        />} } @if(showPendingRequest && !showForwardedReqTable &&
        !showApprovedRequest && !showDeclinedRequest){
        <input
          type="search"
          [(ngModel)]="pendingSearchQuery"
          (keydown.enter)="onSearchPendingInventory()"
           placeholder="please hit enter after typing.."
        />
        @if(pendingSearchQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearPendingSearch()"
        />} } @if(showDeclinedRequest && !showForwardedReqTable &&
        !showApprovedRequest && !showPendingRequest){
        <input
          type="search"
          [(ngModel)]="declinedSearchQuery"
          (keydown.enter)="onSearchDeclinedInventory()"
           placeholder="please hit enter after typing.."
        />
        @if(declinedSearchQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearDeclinedSearch()"
        />} } @if(showForwardedReqTable && !showApprovedRequest &&
        !showPendingRequest && !showDeclinedRequest){
        <input
          type="search"
          [(ngModel)]="forwardedSearchQuery"
          (keydown.enter)="onSearchForwardedInventory()"
           placeholder="please hit enter after typing.."
        />
        @if(forwardedSearchQuery){
        <img
          class="search-close"
          style="cursor: pointer"
          src="../../../assets/closeIcon.png"
          alt=""
          (click)="clearForwardedSearch()"
        />} }
      </div>
      <div
        class="btn-container d-flex align-items-center justify-content-between"
      >
        <!-- <div class="month-type">
          <mat-form-field
            class="example-form-field"
            style="
              width: 240px !important;
              height: 45px !important;
              border: none;
              --mat-form-field-filled-with-label-container-padding-bottom: 0px;
              --mat-form-field-container-height: 0px;
              --mat-form-field-filled-with-label-container-padding-top: 0px;
              --mdc-filled-text-field-container-color: #fff;
              --mat-form-field-container-vertical-padding: 10px;
            "
          >
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate placeholder="Start date" />
              <input matEndDate placeholder="End date" />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="rangePicker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Reset</button>
                <button
                  style="
                    --mdc-protected-button-container-color: #fecc28;
                    --mdc-protected-button-label-text-color: #000;
                  "
                  mat-raised-button
                  color="primary"
                  matDateRangePickerApply
                >
                  Apply
                </button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </div> -->

        <!-- <select id="admin" class="form-control" formControlName="admin" style="margin-left: 15px">
          <option value="admin" selected>All Admins</option>
        </select> -->

        <div class="mat-dropdown-panel">
  <mat-form-field style="width:185px!important; height:45px!important">
    <mat-select 
      [placeholder]="selectedFilter || 'Service Request'" 
      [(value)]="selectedFilter">

      <!-- All Service Requests -->
      @for (serviceRequest of allServiceReq; track $index) {
        <mat-option 
          [value]="serviceRequest.viewValue" 
          (click)="getServiceRequestData()">
          {{ serviceRequest.viewValue }}
        </mat-option>
      }

      <!-- Forwarded Requests -->
      @for (request of requests; track $index) {
        @if (showForwardFilter) {
          <mat-option 
            [value]="request.viewValue" 
            (click)="onRequestSelect(request.value)">
            {{ request.viewValue }}
          </mat-option>
        }
      }

      <!-- Pending Requests -->
      @for (pendingRequest of pendingServiceReq; track $index) {
        <mat-option 
          [value]="pendingRequest.viewValue" 
          (click)="onFilterPendingRequest(pendingRequest.value)">
          {{ pendingRequest.viewValue }}
        </mat-option>
      }

      <!-- Approved Requests -->
      @for (approvedRequest of approvedServiceReq; track $index) {
        <mat-option 
          [value]="approvedRequest.viewValue" 
          (click)="onFilterApprovedRequest(approvedRequest.value)">
          {{ approvedRequest.viewValue }}
        </mat-option>
      }

      <!-- Declined Requests -->
      @for (declinedRequest of declinedServiceReq; track $index) {
        <mat-option 
          [value]="declinedRequest.viewValue" 
          (click)="onFilterDeclinedRequest(declinedRequest.value)">
          {{ declinedRequest.viewValue }}
        </mat-option>
      }

    </mat-select>
  </mat-form-field>
</div>

        <button
          class="d-flex align-items-center justify-content-center new-req"
          type="button"
          data-toggle="modal"
          data-target="#serviceRequestModal"
          style="margin-left: 13px"
          (click)="openServiceForm()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.4em"
            height="1.4em"
            viewBox="0 0 32 32"
            style="margin-right: 8px"
          >
            <path fill="currentColor" d="M17 15V8h-2v7H8v2h7v7h2v-7h7v-2z" />
          </svg>
          Request
        </button>
      </div>
    </div>
  </div>

  <!-- service Request Table -->
  @if (showServiceRequestTable && !showForwardedReqTable &&
    !showApprovedRequest && !showPendingRequest && !showDeclinedRequest ) {
  <div
    class="checked-out-inv service"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 650px;
    "
  >
    @if(!isShimmerLoading){
    <table class="fixed-header-table" style="overflow-x: unset !important; min-height: 650px;">
      <thead>
        <tr>
          <th scope="col" style="width: 15%">ASSET NAME</th>
          <th scope="col" style="width: 15%">REQUESTED BY</th>
          <th scope="col" style="width: 15%">SERVICE TYPE</th>
          <th scope="col" style="width: 15%">DAMAGE</th>
          <th scope="col" style="width: 15%">OTHER DETAILS</th>
          <th scope="col" style="width: 15%">REQUESTED ON</th>
          <th scope="col" style="width: 10%">NEED BY</th>
          <th scope="col" style="width: 10%">URGENCY</th>
          @if (showForwardButton || showActionHeader) {
          <th scope="col" style="width: 15%">ACTIONS</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (serviceReq of serviceRequest; track $index ) {
        <tr data-toggle="modal">
          <td>
            <div class="d-flex align-items-center">
              <p style="margin-bottom: 0; font-size: 13px">{{ $index + 1 }}</p>
              <div class="inventory-img">
                <img
                  [src]="
                    serviceReq.assetImage && serviceReq.assetImage !== '0'
                      ? serviceReq.assetImage
                      : '../../../assets/inventories/default-inventory.png'
                  "
                  alt=""
                  width="60px"
                  height="60px"
                />
              </div>
              <p>{{ serviceReq.assetName }}</p>
            </div>
          </td>
          <td>
            <p>{{ serviceReq.requestedBy }}</p>
          </td>
          @if (showPendingRequest) { @for (pending of pendingReq; track $index)
          {
          <td>
            <p
              [ngClass]="{
                'text-pending': pending.status === 'Pending' || 'Forwarded',
                'text-rejected': pending.status === 'Rejected By tanvi'
              }"
            >
              {{ pending.status }}
            </p>
          </td>
          } }
          <td>
            <p>{{ serviceReq.serviceType }}</p>
          </td>
          <td>
            <p>{{ serviceReq.damage }}</p>
          </td>
          <td>
            <p
              class="details-text"
              title="{{ serviceReq.details }}"
              style="width: 130px; color: #878888"
            >
              {{ serviceReq.details }}
            </p>
          </td>

          <td>
            <p>{{ serviceReq.requestedOn }}</p>
          </td>
          @if (!showPendingRequest) {
          <td>
            <p>{{ serviceReq.needBy }}</p>
          </td>
          }
          <td>
            <p
              [ngClass]="{
                'text-red': serviceReq.urgency === 'High',
                'text-orange': serviceReq.urgency === 'Medium',
                'text-blue': serviceReq.urgency === 'Low'
              }"
            >
              {{ serviceReq.urgency }}
            </p>
          </td>
          @if(showForwardButton ){
          <td>
            <button
              class="forward-req"
              [ngClass]="{ 'forwarded-btn': serviceReq.isForwarded }"
              data-toggle="modal"
              data-target="#forwardServiceRequestModal"
              [disabled]="serviceReq.isForwarded"
              (click)="selectedInventory = serviceReq"
            >
              {{ serviceReq.isForwarded ? "Forwarded" : "Forward Request" }}
            </button>

            <button
              mat-stroked-button
              [class.disabled-button]="serviceReq.isForwarded"
              class="accept"
              style="margin-right: 10px"
              [disabled]="serviceReq.isForwarded"
              (click)="acceptRequest(serviceReq.requestId)"
            >
              Accept
            </button>
            <button
              mat-stroked-button
              [class.disabled-button]="serviceReq.isForwarded"
              class="decline"
              style="margin-right: 10px !important"
              [disabled]="serviceReq.isForwarded"
              (click)="declineRequest(serviceReq.requestId)"
            >
              Decline
            </button>
          </td>
          } @if( loogedUserId === serviceReq.requestedById ){
          <td>
            <button
              type="button"
              class="decline"
              (click)="deleteServiceRequest(serviceReq.requestId, serviceReq.approverId)"
              [class.disabled-button]="serviceReq.isForwarded"
              [disabled]="serviceReq.isForwarded"
            >
              Delete
            </button>
          </td>
          }
        </tr>
        }
      </tbody>
      @if(serviceRequest.length === 0){
      <app-no-data></app-no-data>
      }
    </table>
    } @if(isShimmerLoading) { @for (serviceReq of shimmerLoadingValue; track
    serviceReq; let i = $index) {
    <span class="d-flex">
      <div class="shimmer-card">
        <div class="shimmerBG media"></div>
        <div class="p-32">
          <div class="shimmerBG title-line"></div>
          <div class="shimmerBG title-line end"></div>

          <div class="shimmerBG content-line m-t-24"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line end"></div>
        </div>
      </div>
    </span>
    } }
  </div>
  }

  <!-- Forward Request Table -->
  @if (showForwardedReqTable && !showApprovedRequest && !showPendingRequest
    && !showDeclinedRequest) {
  <div
    class="checked-out-inv"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 650px;
    "
  >
    <table class="fixed-header-table" style="min-height: 650px;">
      <thead>
        <tr>
          <th scope="col">ASSET NAME</th>
          <th scope="col">REQUESTED BY</th>
          <th scope="col">APPROVER</th>
          <th scope="col">STATUS</th>
          <th scope="col">SERVICE TYPE</th>
          <th scope="col">DAMAGE</th>
          <th scope="col">OTHER DETAILS</th>
          <th scope="col">REQUESTED ON</th>
          <th scope="col">NEED BY</th>
          <th scope="col">URGENCY</th>
          <th scope="col">FORWARDED ON</th>
          <th scope="col">FORWARDED TO</th>
          <th scope="col">COMMENT</th>
        </tr>
      </thead>
      <tbody>
        @for (forward of forwardedReq; track $index) {
        <tr data-toggle="modal" data-target="#requestDetailModal">
          <td>
            <div class="d-flex align-items-center">
              <div class="inventory-img">
                <img
                  [src]="
                    forward.assetImage && forward.assetImage !== '0'
                      ? forward.assetImage
                      : '../../../../assets/inventories/default-inventory.png'
                  "
                  alt=""
                  width="60px"
                  height="60px"
                />
              </div>
              <p>{{ forward.assetName }}</p>
            </div>
          </td>
          <td>
            <p>{{ forward.requestedBy }}</p>
          </td>
          <td class="project-name">
            <p>{{ forward.approver }}</p>
          </td>
          <td>
            <p class="status-point">{{ forward.status }}</p>
          </td>
          <td>
            <p>{{ forward.serviceType }}</p>
          </td>
          <td>
            <p>{{ forward.damage }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.details }}
            </p>
          </td>
          <td>
            <p>{{ forward.requestedOn }}</p>
          </td>
          <td>
            <p>{{ forward.needBy }}</p>
          </td>
          <td>
            <p class="urgency">{{ forward.urgency }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedOn }}</p>
          </td>
          <td>
            <p>{{ forward.forwardedTo }}</p>
          </td>
          <td>
            <p class="other-details">
              {{ forward.comment }}
            </p>
          </td>
        </tr>
        }
      </tbody>
       @if(forwardedReq.length === 0){
    <app-no-data></app-no-data>
    }
    </table>
   
  </div>
  }

  <!-- Service Pending Request Table -->
  @if (showPendingRequest ) {
  <div class="checkout-request">
    <div
      class="checked-out-inv"
      infiniteScroll
      #infiniteScroller
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
      style="
        max-height: calc(100vh - 155px);
        overflow-y: scroll;
        min-height: 650px;
      "
    >
      <table class="fixed-header-table" style="min-height: 650px;">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 20%">ASSET NAME</th>
            <th scope="col" style="width: 15%">REQUESTED ON</th>
            <th scope="col" style="width: 15%">SERVICE TYPE</th>
            <th scope="col" style="width: 15%">DAMAGE TYPE</th>
            <th scope="col" style="width: 15%">STATUS</th>
            <th scope="col" style="width: 20%">DETAIL</th>
            <th scope="col" style="width: 20%">URGENCY</th>
          </tr>
        </thead>
        <tbody>
          @for (pending of pendingReq; track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      pending.assetImage && pending.assetImage !== '0'
                        ? pending.assetImage
                        : '../../../../assets/inventories/default-inventory.png'
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>
                <p>{{ pending.assetName }}</p>
              </div>
            </td>
            <td>
              <p>{{ pending.requestedOn }}</p>
            </td>
            <td>
              <p>{{ pending.serviceType }}</p>
            </td>
            <td>
              <p>{{ pending.damageType }}</p>
            </td>
            <td>
              <p
                [ngClass]="{
                  'text-pending': pending.status === 'Pending' || 'Forwarded',
                  'text-rejected': pending.status === 'Rejected By tanvi'
                }"
              >
                {{ pending.status }}
              </p>
            </td>
            <td>
              <p>{{ pending.detail }}</p>
            </td>
            <td>
              <p
                [ngClass]="{
                  'text-red': pending.urgency === 'High',
                  'text-orange': pending.urgency === 'Medium',
                  'text-blue': pending.urgency === 'Low'
                }"
              >
                {{ pending.urgency }}
              </p>
            </td>
          </tr>
          }
        </tbody>
        @if(pendingReq.length === 0){
      <app-no-data></app-no-data>
      }
      </table>
      
    </div>
  </div>
  }

  <!-- Approved Requests Table -->
  @if (showApprovedRequest) {
  <div
    class="checkout-request service-approved"
    infiniteScroll
    #infiniteScroller
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 650px;
    "
  >
    <div
      class="checked-out-inv approved"
      style="overflow: auto; max-height: calc(100vh - 160px)"
    >
      <table class="fixed-header-table" style="min-height: 650px;">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 400px">ASSET NAME</th>
            <th scope="col" style="width: 400px">REQUESTED ON</th>
            <th scope="col" style="width: 400px">REQUESTED BY</th>
            <th scope="col" style="width: 400px">SERVICE TYPE</th>
            <th scope="col" style="width: 400px">DAMAGE TYPE</th>
            <th scope="col" style="width: 400px">DETAIL</th>
            <th scope="col" style="width: 400px">STATUS</th>
            <th scope="col" style="width: 200px">URGENCY</th>
          </tr>
        </thead>
        <tbody>
          @for (approve of approveInv; track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>

                <div class="inventory-img">
                  <img
                    [src]="
                      approve.assetImage && approve.assetImage !== '0'
                        ? approve.assetImage
                        : '../../../../assets/inventories/default-inventory.png '
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>

                <p>{{ approve.assetName }}</p>
              </div>
            </td>
            <td>
              <p>{{ approve.requestedOn }}</p>
            </td>
               <td>
              <p>{{ approve.requestedByName }}</p>
            </td>
            <td>
              <p>{{ approve.serviceType }}</p>
            </td>
            <td>
              <p>{{ approve.damageType }}</p>
            </td>
            <td>
              <p>{{ approve.detail }}</p>
            </td>
            <td>
              <p style="color: #24ba61">{{ approve.status }}</p>
            </td>
            <td>
              <p
                [ngClass]="{
                  'text-red': approve.urgency === 'High',
                  'text-orange': approve.urgency === 'Medium',
                  'text-blue': approve.urgency === 'Low'
                }"
              >
                {{ approve.urgency }}
              </p>
            </td>

            <!-- <td>
              <button type="button" class="accept">Submit Images</button>
            </td> -->
          </tr>
          }
        </tbody>
      </table>
    </div>
    @if(approveInv.length === 0){
    <app-no-data></app-no-data>
    }
  </div>
  }

  <!-- Declined Requests Table -->
  @if (showDeclinedRequest) {
  <div class="checkout-request">
    <div
      class="checked-out-inv"
      infiniteScroll
      #infiniteScroller
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
      style="
        max-height: calc(100vh - 155px);
        overflow-y: scroll;
       min-height: 650px;
        overflow-x: unset !important;
      "
    >
      <table class="fixed-header-table" style="overflow-x: unset !important">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 400px">ASSET NAME</th>
            <th scope="col" style="width: 400px">REQUESTED ON</th>
            <th scope="col" style="width: 200px">REQUESTED BY</th>
            <th scope="col" style="width: 400px">SERVICE TYPE</th>
            <th scope="col" style="width: 400px">DAMAGE TYPE</th>
            <th scope="col" style="width: 400px">DETAIL</th>
            <th scope="col" style="width: 400px">STATUS</th>
            <th scope="col" style="width: 200px">URGENCY</th>

          </tr>
        </thead>
        <tbody>
          @for (decline of declineInv; track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      decline.assetImage && decline.assetImage !== '0'
                        ? decline.assetImage
                        : '../../../../assets/inventories/default-inventory.png '
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>

                <p>{{ decline.assetName }}</p>
              </div>
            </td>
            <td>
              <p>{{ decline.requestedOn }}</p>
            </td>
            <td>
              <p >{{ decline.requestedBy }}</p>
            </td>
            <td>
              <p>{{ decline.serviceType }}</p>
            </td>
            <td>
              <p>{{ decline.damage }}</p>
            </td>
            <td>
              <p class="details-text" title="{{ decline.details }}">
                {{ decline.details }}
              </p>
            </td>
            <td>
              <p style="color: red">{{ decline.status }}</p>
            </td>
            <td>
              <p
                [ngClass]="{
                  'text-red': decline.urgency === 'High',
                  'text-orange': decline.urgency === 'Medium',
                  'text-blue': decline.urgency === 'Low'
                }"
              >
                {{ decline.urgency }}
              </p>
            </td>
            

            <!-- <td>
                <button type="button" class="accept">Submit Images</button>
              </td> -->
          </tr>
          }
        </tbody>
      </table>
      @if(declineInv.length === 0){
      <app-no-data></app-no-data>
      }
    </div>
  </div>
  }
</div>

<!-- Service Request Modal -->
<div
  class="modal fade"
  id="serviceRequestModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addInventoryModalTitle"
  aria-hidden="true"
  data-backdrop="static"
  style="backdrop-filter: brightness(0.5)"
>
  <div
    class="modal-dialog modal-dialog-centered main-width-content"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header addInventory-head">
        @if (!formSubmitted) {
        <h5 class="modal-title" id="addInventoryModalTitle">
          Create A Service Request
        </h5>
        }
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeServiceRequestModal()"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body service-req-modal-body">
        @if (!formSubmitted) {
        <div class="new-inventory-container">
          <form
            class="service-form"
            [formGroup]="serviceRequestForm"
            (ngSubmit)="onServiceReqSubmit()"
          >
            <div class="service-form-grid">
              <div class="form-group">
                <label for="assetCategory" class="form-label asterisk-lbl"
                  >Select Inventory</label
                >

                <div
                  [ngClass]="{
                    'has-error':
                      serviceRequestForm.get('assignedInventoryId')?.invalid &&
                      (serviceRequestForm.get('assignedInventoryId')?.dirty ||
                        serviceRequestForm.get('assignedInventoryId')
                          ?.touched ||
                        submitted)
                  }"
                >
                  <mat-form-field class="w-100">
                    <div
                      class="d-flex justify-content-between align-items-center w-100"
                      style="width: 100%; height: 100%;"
                    >
                      <input
                        class="sel-inv"
                        type="text"
                        placeholder="search Inventory"
                        aria-label="Number"
                        matInput
                        [formControl]="selectedInventoryControl"
                        [matAutocomplete]="auto"
                        style="
                          border: none;
                          height: auto;
                          border-radius: 0px;
                          padding-left: 0px !important;
                          flex: 1;
                          width: 100%;
                          outline: none;
                        "
                        [(ngModel)]="searchQuery"
                        (keydown.enter)="onSearchInventory($event)"
                      />
                      @if(searchQuery){
                      <img
                        class="search-close"
                        style="cursor: pointer"
                        src="../../../assets/closeIcon.png"
                        alt=""
                        (click)="clearSearch()"
                      />
                      } @if(!searchQuery){
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1.2em"
                        height="1.2em"
                        viewBox="0 0 24 24"
                        style="cursor: pointer; flex-shrink: 0;"
                      >
                        <path
                          fill="currentColor"
                          d="M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15a1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16"
                        />
                      </svg>
                      }
                    </div>
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      (optionSelected)="onInventoryChange($event)"
                      [displayWith]="displayFn"
                    >
                      @for (inventories of inventory; track $index) {
                      <mat-option [value]="inventories">
                        <div style="display: flex; align-items: center">
                          <img
                            [src]="
                              inventories.assetImage &&
                              inventories.assetImage !== '0' &&
                              inventories.assetImage.trim() !== ''
                                ? inventories.assetImage
                                : '../../../assets/inventories/default-inventory.png'
                            "
                            alt=""
                            width="30px"
                            height="30px"
                            style="margin-right: 10px"
                          />
                          <span style="white-space: normal">{{
                            inventories.viewValue
                          }}</span>
                        </div>
                      </mat-option>

                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                @if(serviceRequestForm.get('assignedInventoryId').invalid &&
                (serviceRequestForm.get('assignedInventoryId').dirty ||
                serviceRequestForm.get('assignedInventoryId').touched ||
                submitted)){
                <div class="validation-message">Please select a inventory.</div>
                }

                @if(inventory.length === 0){
  <div class="validation-message" style="color: red; margin-top: 5px;">
    No inventory available. Please add inventory before creating a service request.
  </div>
}

              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error':
                    serviceRequestForm.get('needByDate').invalid &&
                    (serviceRequestForm.get('needByDate').dirty ||
                      serviceRequestForm.get('needByDate').touched ||
                      submitted)
                }"
              >
                <label for="needByDate" class="form-label asterisk-lbl"
                  >Need by Date</label
                >
                <input
                  type="date"
                  class="form-control"
                  id="needByDate"
                  formControlName="needByDate"
                  [min]="today"
                  (keydown)="disableTyping($event)"
                />
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error':
                    serviceRequestForm.get('damageType').invalid &&
                    (serviceRequestForm.get('damageType').dirty ||
                      serviceRequestForm.get('damageType').touched ||
                      submitted)
                }"
              >
                <label for="damageType" class="form-label asterisk-lbl"
                  >Damage Type</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="damageType"
                  formControlName="damageType"
                />
                @if(serviceRequestForm.get('damageType').errors?.maxlength){
                <div style="color: red">
                  Damage type cannot exceed 100 characters.
                </div>
                }
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error':
                    serviceRequestForm.get('urgency').invalid &&
                    (serviceRequestForm.get('urgency').dirty ||
                      serviceRequestForm.get('urgency').touched ||
                      submitted)
                }"
              >
                <label for="urgency" class="form-label asterisk-lbl"
                  >Urgency</label
                >

                <mat-form-field class="w-100">
                  <mat-select formControlName="urgency" placeholder="select">
                    @for (urgency of urgencies; track urgency) {
                    <mat-option [value]="urgency.value">{{
                      urgency.viewValue
                    }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                class="form-group"
                [ngClass]="{
                  'has-error':
                    serviceRequestForm.get('serviceType').invalid &&
                    (serviceRequestForm.get('serviceType').dirty ||
                      serviceRequestForm.get('serviceType').touched ||
                      submitted)
                }"
              >
                <label for="serviceType" class="form-label asterisk-lbl"
                  >Service Type</label
                >
                <mat-form-field class="w-100">
                  <mat-select
                    formControlName="serviceType"
                    placeholder="select"
                  >
                    @for (service of services; track service) {
                    <mat-option [value]="service.value">{{
                      service.viewValue
                    }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              @if(showForwardButton){
              <div
                class="form-group maximum-cost-input"
                [ngClass]="{
                  'has-error':
                    serviceRequestForm.get('maximumCost').invalid &&
                    (serviceRequestForm.get('maximumCost').dirty ||
                      serviceRequestForm.get('maximumCost').touched ||
                      submitted)
                }"
              >
                <label for="maximumCost" class="form-label asterisk-lbl"
                  >Maximum Cost(₹)</label
                >
                <input
                  type="text"
                  id="maximumCost"
                  class="form-control"
                  formControlName="maximumCost"
                  (keypress)="blockNonNumeric($event)"
                  (input)="onProductCostInput($event)"
                />
              </div>
              }

              @if(!showForwardButton){
              <div class="form-group">
                <label for="approverName" class="form-label"
                  >Select Approver</label
                >
                <mat-form-field class="w-100">
                  <mat-select
                    formControlName="approverName"
                    placeholder="select"
                  >
                    @for (approver of approverUsers; track approver.id) {
                    <mat-option [value]="approver.value">{{
                      approver.viewValue
                    }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }

              @if(showForwardButton){
              <div class="form-group">
                <label for="approverName" class="form-label"
                  >Select Approver</label
                >
                <mat-form-field class="w-100">
                  <mat-select
                    formControlName="approverName"
                    placeholder="select"
                  >
                    @for (approver of approverUsers; track approver.id) {
                    <mat-option [value]="approver.value">{{
                      approver.viewValue
                    }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }

              <div class="form-group col-span-2 mention-detail">
                <label for="detail" class="form-label">Mention in Details</label>
                <textarea
                  id="detail"
                  rows="3"
                  class="form-control"
                  formControlName="detail"
                ></textarea>
                @if(serviceRequestForm.get('detail').errors?.maxlength){
                <div style="color: red">
                  Details cannot exceed 200 characters.
                </div>
                }
              </div>

              @if(showForwardButton){
              <div
                class="form-group col-span-2 comment-field d-flex flex-column"
                [ngClass]="{
                  'has-error':
                    serviceRequestForm.get('comment').invalid &&
                    (serviceRequestForm.get('comment').dirty ||
                      serviceRequestForm.get('comment').touched ||
                      submitted)
                }"
              >
                <label class="asterisk-lbl" for="comment">Comment</label>
                <textarea
                  id="comment"
                  placeholder="Add your comment"
                  name="comment"
                  rows="3"
                  class="form-control"
                  formControlName="comment"
                >
                </textarea>
              </div>
              }

              <div class="form-actions d-flex justify-content-end align-items-center">
                <button
                  type="submit"
                  class="btn btn-warning d-flex justify-content-center align-items-center"
                  style="margin-top: 24px"
                >
                  Submit
                  @if(isFormSubmitting){
                  <div class="loader-circle" style="margin-left:8px;"></div>
                  }
                </button>
              </div>
            </div>
          </form>
          @if (errorMessage) {
          <div class="alert alert-danger mt-3">
            {{ errorMessage }}
            <button type="button" class="close" data-dismiss="alert">
              <svg
                class="cross-svg"
                width="14"
                height="12"
                viewBox="0 0 14 14"
                fill="none"
                style="margin-bottom: 5px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5518 1.64453L1.85612 12.3402"
                  stroke="#25252B"
                  stroke-width="2.26313"
                  stroke-linecap="round"
                />
                <path
                  d="M12.5518 12.3401L1.85612 1.64445"
                  stroke="#25252B"
                  stroke-width="2.26313"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          </div>
          }
        </div>
        } @if (formSubmitted) {
        <div class="text-center" style="padding: 30px 0">
          <svg
            width="76"
            height="76"
            viewBox="0 0 76 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.7808 3.91014C46.0698 3.91014 54.0763 6.92354 60.3083 12.3889C66.5404 17.8543 70.573 25.3989 71.655 33.617C72.7369 41.8352 70.7943 50.1664 66.1892 57.0586C61.584 63.9507 54.6303 68.9336 46.6237 71.079C38.6171 73.2244 30.1035 72.3858 22.6693 68.7197C15.2351 65.0535 9.38711 58.8097 6.21502 51.1516C3.04292 43.4935 2.76302 34.9434 5.42745 27.0942C8.09189 19.245 13.5189 12.6321 20.6975 8.48759"
              stroke="#24BA61"
              stroke-width="6.40622"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.9683 38.0768L33.5099 46.6184L50.5932 29.5352"
              stroke="#24BA61"
              stroke-width="5.33852"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <h3 style="padding: 15px 0; font-weight: 600">Request Submitted!</h3>
          <p style="font-weight: 600; padding-bottom: 30px">
            Your request has been submitted, you’ll be notified when it gets<br />
            approved and for further steps
          </p>
          <div class="d-flex justify-content-center align-items-center">
            <button
              class="btn btn-warning close"
              style="width: 210px; opacity: 1; font-size: 16px; height: 48px"
              data-dismiss="modal"
              aria-label="Close"
              (click)="closeServiceRequestModal()"
            >
              Okay
            </button>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<app-forward-service-req
  [selectedServiceInventory]="selectedInventory"
  (requestForwarded)="handleRequestForwarded($event)"
></app-forward-service-req>

<!-- Request Details Modal -->
<div
  class="modal fade"
  id="requestDetailModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="requestDetailTitle"
  aria-hidden="true"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered req-dtl-width" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Request Details</h1>
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body request-detail-container">
        <div class="req-dtl-content">
          <div class="req-top d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div class="inventory-img">
                <img src="../../../../assets/inventories/drone.png" alt="" />
              </div>
              <p style="margin-left: 25px; width: 50%">
                DJI Mini 4 Pro Fly More Combo
              </p>
            </div>
            <div class="status">
              <h2>Status</h2>
              <p class="status-point">Forwarded for Approval</p>
            </div>
            <div class="status">
              <h2>Requested by</h2>
              <p>Anoop Kumar</p>
            </div>
            <div class="status">
              <h2>Date</h2>
              <p>June 18</p>
            </div>
            <div class="status">
              <h2>Requested to</h2>
              <p>Tanvi Singh</p>
            </div>
            <div class="status">
              <h2>Approved by</h2>
              <p>Mohd Shaizi</p>
            </div>
          </div>
          <div class="req-bottom">
            <h2>Comment by Mohd Shaizi</h2>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa
              cupiditate modi mollitia illo, explicabo ratione error odit vitae
              rem ullam. Lorem ipsum dolor sit amet consectetur, adipisicing
              elit. Voluptatem, vero consequuntur. Corrupti facere iusto quis.
            </p>
          </div>
        </div>
        <div class="approver-cont d-flex">
          <div class="approver">
            <h2>Approver</h2>
            <p>Manish Kakkar</p>
          </div>
          <div class="approver">
            <h2>Sent for Approval</h2>
            <p>June 22</p>
          </div>
          <div class="approver">
            <h2>Urgency</h2>
            <p>Urgent</p>
          </div>
          <div class="approver">
            <h2>Cost</h2>
            <p>25000</p>
          </div>
          <div class="approver">
            <h2>Status</h2>
            <p class="approver-point">Pending</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Allow Inventory Request Modal -->
<div
  class="modal fade"
  id="allowRequestModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="allowRequestTitle"
  aria-hidden="true"
  data-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-centered forward-req-width"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h2 style="font-size: 26px">Allow Inventory Request</h2>
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body forward-req-container">
        <div class="sent-req-content">
          <img src="/assets/inventories/qr-code.png" alt="" />

          <p>Please Scan the QR to continue</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Upload Asset Images Modal -->
<div
  class="modal fade"
  id="allowRequestModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="allowRequestTitle"
  aria-hidden="true"
  data-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-centered forward-req-width"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h2 style="font-size: 26px">Upload Asset Images</h2>
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body forward-req-container">
        <div class="sent-req-content">
          <img src="/assets/inventories/qr-code.png" alt="" />

          <p>Please Scan the QR to continue</p>
        </div>
      </div>
    </div>
  </div>
</div>
